import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:1337",
  headers: {
    "Content-Type": "application/json",
  },
});

// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token && !config.url?.includes("/auth/local")) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const authApi = {
  login: (identifier: string, password: string) =>
    api.post("/api/auth/local", { identifier, password }),
};

export const camerasApi = {
  getAll: async (params?: Record<string, string>) => {
    const response = await api.get("/api/cameras", {
      params: { populate: "*", ...params }
    });
    
    // Document Service может вернуть:
    // 1. { data: [{ id, documentId, attributes }] }
    // 2. [{ id, documentId, ... }] - напрямую массив
    console.log('API response:', response.data);
    
    let items: any[] = [];
    if (Array.isArray(response.data)) {
      items = response.data;
    } else if (response.data.data && Array.isArray(response.data.data)) {
      items = response.data.data;
    }
    
    // Преобразуем в плоский формат
    return items.map((item: any) => {
      // Проверяем формат - может быть с attributes или напрямую
      const data = item.attributes || item;
      return {
        id: item.id,
        documentId: item.documentId || item.id?.toString(),
        name: data.name,
        streamUrl: data.streamUrl,
        cameraStatus: data.cameraStatus,
        address: data.address,
        objectName: data.objectName,
        installationType: data.installationType,
      };
    });
  },

  getOne: async (documentId: string) => {
    const response = await api.get(`/api/cameras/${documentId}`, {
      params: { populate: "*" }
    });
    
    let item = response.data;
    if (item.data) {
      item = item.data;
    }
    
    const data = item.attributes || item;
    return {
      id: item.id,
      documentId: item.documentId || item.id?.toString(),
      name: data.name,
      streamUrl: data.streamUrl,
      cameraStatus: data.cameraStatus,
      address: data.address,
      objectName: data.objectName,
      installationType: data.installationType,
    };
  },
};

export default api;
